/**
 * LayoutContainer
 */

import React from "react"
import { Container } from "./styles"

export const LayoutContainer = props => {
  return (
    <Container
      noPadding={props.noPadding}
      narrow={props.narrow}
      xLarge={props.xLarge}
      large={props.large}
      medium={props.medium}
      fullwidth={props.fullwidth}
      margin={props.margin}
    >
      {props.children}
    </Container>
  )
}

export default LayoutContainer
